$(document).ready(function () {
  // load each of the Altos components files here
  require('./components/user-sub-menu');
  require('./components/header');
  require('./components/sidebar');
  require('./components/search');
  require('./components/accordion');
  require('./components/tab-to-accordion');
  require('./components/forms');
  require('./components/carouselfix');
});
